<template>

    <div>

        <vue-swing v-show="step === ENUM.STEPS.TUTO.UNSUBSCRIBES"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutleft="$emit('next')"
                   :config="configUnsubscribes">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>


        <vue-swing v-show="step === ENUM.STEPS.TUTO.DELETE"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutup="$emit('next')"
                   :config="configDelete">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>


        <vue-swing v-show="step === ENUM.STEPS.TUTO.LATER"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutdown="$emit('next')"
                   :config="configLater">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>


        <vue-swing v-show="step === ENUM.STEPS.TUTO.KEEP"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutright="$emit('next')"
                   :config="configKeep">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>

    </div>

</template>

<script>
import VueSwing from 'vue-swing'

import ENUM from '@/assets/ENUM'

export default {

    name: 'tuto-cards',

    props: {
        step: {
            type: String,
            default: ''
        }
    },

    components: {
        VueSwing
    },

    computed: {

        ENUM() {
            return ENUM
        },

        cardImage() {

            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    return '/img/newsletters-v2/card-unsubscribes.svg'
                case ENUM.STEPS.TUTO.DELETE:
                    return '/img/newsletters-v2/card-delete.svg'
                case ENUM.STEPS.TUTO.KEEP:
                    return '/img/newsletters-v2/card-keep.svg'
                case ENUM.STEPS.TUTO.LATER:
                    return '/img/newsletters-v2/card-later.svg'
            }
        },

        configUnsubscribes() {
            return {
                allowedDirections: [VueSwing.Direction.LEFT]
            }
        },

        configDelete() {
            return {
                allowedDirections: [VueSwing.Direction.UP]
            }
        },

        configLater() {
            return {
                allowedDirections: [VueSwing.Direction.DOWN]
            }
        },

        configKeep() {
            return {
                allowedDirections: [VueSwing.Direction.RIGHT]
            }
        }
    }

}
</script>

<style lang="scss" scoped>

.tuto-cards {
    width: 100%;
    object-fit: contain;

    &__swing {
        display: flex;
        flex-grow: 1;
    }
}
</style>
